import { pinyin } from 'pinyin-pro' // 引入拼音库
// 核心方法：逐字符转换，汉字转首字母，数字英文原样保留
const convertToFirstLetter=(str) =>{
  if (!str) return ''
  let result = ''
  for (const char of str) {
    // 判断是否为汉字
    if (/[\u4e00-\u9fa5]/.test(char)) {
      // 汉字转拼音首字母（大写）
      result += pinyin(char, { pattern: 'first', toneType: 'none' })
    } else {
      // 数字、英文、符号等原样保留
      result += char
    }
  }
  return result.toUpperCase()
}
export default convertToFirstLetter